<pr-form
  (onSubmit)="submit()"
  [title]="title"
  [formGroup]="form"
  clazz="drawer-form"
>
  <div class="add-button-container">
    <pr-button display="neutral" (click)="addBudget()">
      <span>Ajouter</span>
    </pr-button>
  </div>
  <div formArrayName="budgets">
    @for (index of manualBudgets; track index) {
      <div
        [formGroupName]="index"
        class="budget-item"
        [class.collapsed]="isCollapsed(index)"
      >
        <div class="budget-header" (click)="toggleCollapse(index)">
          <div class="budget-header-left">
            <pr-icon class="budget-icon" name="edit"></pr-icon>
            <span class="budget-title">{{ getBudgetTitle(index) }}</span>
            @if (!budgetsArray.at(index).get('id')?.value) {
              <span class="badge-new">New</span>
            }
          </div>
          <div class="budget-header-right">
            <pr-icon
              [name]="isCollapsed(index) ? 'fa-caret-down' : 'fa-caret-up'"
            ></pr-icon>
            @if (!budgetsArray.at(index).get('automatic')?.value) {
              <pr-button
                display="danger"
                (click)="removeBudget(index); $event.stopPropagation()"
              >
                <pr-icon name="delete"></pr-icon>
              </pr-button>
            }
          </div>
        </div>

        @if (!isCollapsed(index)) {
          <div class="budget-content">
            <input formControlName="id" type="hidden" />
            <input formControlName="accountId" type="hidden" />
            <input formControlName="automatic" type="hidden" />
            <input formControlName="budgetType" type="hidden" />

            <pr-input label="Fréquence" [derrors]="derrors">
              <mat-select formControlName="frequency">
                @for (frequency of frequencies; track frequency.id) {
                  <mat-option [value]="frequency.id">
                    {{ frequency.label }}
                  </mat-option>
                }
              </mat-select>
            </pr-input>

            <pr-input label="Catégorie" [derrors]="derrors">
              <mat-select formControlName="category">
                @for (
                  category of getCategories(
                    budgetsArray.at(index).get('budgetType')?.value
                  );
                  track category.id
                ) {
                  <mat-option [value]="category.id">
                    {{ category.label }}
                  </mat-option>
                }
              </mat-select>
            </pr-input>

            @if (budgetsArray.at(index).get('category')?.value) {
              <pr-input label="Type" [derrors]="derrors">
                <mat-select formControlName="type">
                  @for (
                    type of getTypes(
                      budgetsArray.at(index).get('budgetType')?.value,
                      budgetsArray.at(index).get('category')?.value
                    );
                    track type.id
                  ) {
                    <mat-option [value]="type.id">
                      {{ type.label }}
                    </mat-option>
                  }
                </mat-select>
              </pr-input>
            }
            @if (
              budgetsArray.at(index).get('category')?.value &&
              budgetsArray.at(index).get('type')?.value?.includes('OTHER')
            ) {
              <pr-input label="Libellé" [derrors]="derrors">
                <input formControlName="label" type="text" />
              </pr-input>
            }

            <pr-input label="Montant" [derrors]="derrors">
              <input formControlName="amount" type="text" />
            </pr-input>
          </div>
        }
      </div>
    }

    @if (automaticBudgets.length > 0) {
      <div class="automatic-group">
        <div
          class="automatic-header"
          (click)="isAutomaticGroupOpen = !isAutomaticGroupOpen"
        >
          <span class="automatic-title"
            >Budgets automatiques ({{ automaticBudgets.length }})</span
          >
          @if (!isAutomaticGroupOpen) {
            <pr-icon name="fa-caret-down"></pr-icon>
          }
          @if (isAutomaticGroupOpen) {
            <pr-icon name="fa-caret-up"></pr-icon>
          }
        </div>
        @if (isAutomaticGroupOpen) {
          <div class="automatic-content">
            @for (index of automaticBudgets; track index) {
              <div>
                <div
                  [formGroupName]="index"
                  class="budget-item automatic"
                  [class.collapsed]="isCollapsed(index)"
                >
                  <div class="budget-header" (click)="toggleCollapse(index)">
                    <div class="budget-header-left">
                      <span class="budget-title">{{
                        getBudgetTitle(index)
                      }}</span>
                    </div>
                    <div class="budget-header-right">
                      <pr-icon
                        [name]="
                          isCollapsed(index) ? 'fa-caret-down' : 'fa-caret-up'
                        "
                      ></pr-icon>
                    </div>
                  </div>

                  @if (!isCollapsed(index)) {
                    <div class="budget-content">
                      <div class="info-row">
                        <span class="info-label">Catégorie:</span>
                        <span class="info-value"
                          >{{
                            getCategoriesLabel(budgetsArray.at(index).value)
                          }}
                        </span>
                      </div>

                      @if (budgetsArray.at(index).get('category')?.value) {
                        <div class="info-row">
                          <span class="info-label">Type:</span>
                          <span class="info-value">{{
                            getTypesLabel(budgetsArray.at(index).value)
                          }}</span>
                        </div>
                      }

                      <div class="info-row">
                        <span class="info-label">Libellé:</span>
                        <span class="info-value">{{
                          budgetsArray.at(index).get('label')?.value
                        }}</span>
                      </div>

                      <div class="info-row">
                        <span class="info-label">Montant:</span>
                        <span class="info-value">
                          {{
                            budgetsArray.at(index).get('amount')?.value
                              | currency: 'EUR' : 'symbol' : '.0-0'
                          }}
                        </span>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</pr-form>
